import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { Type } from '@uswitch/spark.type';
import { getVariantPath } from '@uswitch/spark.utils';
import React from 'react';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
var tableVariantPath = getVariantPath({
  id: 'table'
});
var thVariantPath = getVariantPath({
  id: 'table',
  element: 'th'
});
var trVariantPath = getVariantPath({
  id: 'table',
  element: 'tr'
});
var tdVariantPath = getVariantPath({
  id: 'table',
  element: 'td'
});
/**
 * Tables allow to structure content in a grid to facilitate understanding.
 */

export var Table = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$as = _ref.as,
      As = _ref$as === void 0 ? 'table' : _ref$as,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["as", "children"]);

  return _jsx(As, _objectSpread(_objectSpread({
    ref: ref,
    sx: {
      variant: tableVariantPath()
    }
  }, props), {}, {
    children: children
  }));
});
export var Thead = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var _ref2$as = _ref2.as,
      As = _ref2$as === void 0 ? 'thead' : _ref2$as,
      children = _ref2.children,
      props = _objectWithoutProperties(_ref2, ["as", "children"]);

  return _jsx(As, _objectSpread(_objectSpread({
    ref: ref
  }, props), {}, {
    children: children
  }));
});
export var Tbody = /*#__PURE__*/React.forwardRef(function (_ref3, ref) {
  var _ref3$as = _ref3.as,
      As = _ref3$as === void 0 ? 'tbody' : _ref3$as,
      children = _ref3.children,
      props = _objectWithoutProperties(_ref3, ["as", "children"]);

  return _jsx(As, _objectSpread(_objectSpread({
    ref: ref
  }, props), {}, {
    children: children
  }));
});
export var Th = /*#__PURE__*/React.forwardRef(function (_ref4, ref) {
  var _ref4$as = _ref4.as,
      as = _ref4$as === void 0 ? 'th' : _ref4$as,
      children = _ref4.children,
      props = _objectWithoutProperties(_ref4, ["as", "children"]);

  return _jsx(Type.Body1, _objectSpread(_objectSpread({
    ref: ref,
    sx: {
      variant: thVariantPath()
    }
  }, props), {}, {
    as: as,
    children: children
  }));
});
export var Tr = /*#__PURE__*/React.forwardRef(function (_ref5, ref) {
  var _ref5$as = _ref5.as,
      As = _ref5$as === void 0 ? 'tr' : _ref5$as,
      children = _ref5.children,
      borderBottom = _ref5.borderBottom,
      striped = _ref5.striped,
      props = _objectWithoutProperties(_ref5, ["as", "children", "borderBottom", "striped"]);

  var styles;

  if (borderBottom && striped) {
    styles = trVariantPath('borderBottomStriped');
  } else if (borderBottom) {
    styles = trVariantPath('borderBottom');
  } else if (striped) {
    styles = trVariantPath('striped');
  } else {
    styles = trVariantPath();
  }

  return _jsx(As, _objectSpread(_objectSpread({
    ref: ref,
    sx: {
      variant: styles
    }
  }, props), {}, {
    children: children
  }));
});
export var Td = /*#__PURE__*/React.forwardRef(function (_ref6, ref) {
  var _ref6$as = _ref6.as,
      as = _ref6$as === void 0 ? 'td' : _ref6$as,
      children = _ref6.children,
      props = _objectWithoutProperties(_ref6, ["as", "children"]);

  return _jsx(Type.Body2, _objectSpread(_objectSpread({
    ref: ref,
    sx: {
      variant: tdVariantPath()
    }
  }, props), {}, {
    as: as,
    children: children
  }));
});